import { COVERAGES_ASSIGN_TYPES } from "./coveragesAssignTypes";

const {
  SET_ASSIGNED_COVERAGES,
  SET_DELETED_ASSIGNED_COVERAGE,
  SET_STATION_UNITS,
  SET_NEW_ASSIGNED_COVERAGE,
  DELETE_ASSIGNATION_MODE,
  SET_SELECTED_ASSIGNATION,
  EDIT_ASSIGNATION_MODE,
  NEW_ASSIGNATION,
  SET_EDITED_ASSIGNATION,
  SET_COVERAGES_ASSIGN_FILTERS
} = COVERAGES_ASSIGN_TYPES;

const initialState = {
  assignedCoverages: [],
  stationUnits: [],
  assignedCoverageSelected: null,
  statusList: [{ value: 'ACTIVE', label: 'ACTIVO' }, { value: 'INACTIVE', label: 'INACTIVO' }],
  startDate: null,
  endDate: null,
  station: null,

  //edit
  addMode: false,
  deleteMode: false
};

export const coveragesAssignReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case NEW_ASSIGNATION: {
      return {
        ...state,
        addMode: true
      }
    }
    case SET_NEW_ASSIGNED_COVERAGE: {
      const newAssignedCoverage = [payload, ...state.assignedCoverages];

      return {
        ...state,
        assignedCoverages: newAssignedCoverage
      };
    }
    case SET_EDITED_ASSIGNATION: {
      const newAssignations = [...state.assignedCoverages];
      const indexToEdit = newAssignations.findIndex(assignation => assignation.id === payload.id);

      if (indexToEdit !== -1) {
        newAssignations[indexToEdit] = payload;
      }
      return {
        ...state,
        assignedCoverages: newAssignations,
        assignedCoverageSelected: null,
        addMode: false,
        deleteMode: false
      };
    }
    case SET_SELECTED_ASSIGNATION:
      return {
        ...state,
        assignedCoverageSelected: payload

      };
    case EDIT_ASSIGNATION_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      };
    case DELETE_ASSIGNATION_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      };
    case SET_DELETED_ASSIGNED_COVERAGE:
      return {
        ...state,
        assignedCoverages: state.assignedCoverages.filter(coverage => coverage.id !== payload),
        deleteMode: false
      }
    case SET_ASSIGNED_COVERAGES:
      return {
        ...state,
        assignedCoverages: payload,
        isLoadingPage: false
      };
    case SET_STATION_UNITS:
      return {
        ...state,
        stationUnits: payload
      }

    case SET_COVERAGES_ASSIGN_FILTERS: {
      const allowedKeys = ["startDate", "endDate", "station"];
      if (!allowedKeys.includes(payload.key)) return state;
      return {
        ...state,
        [payload.key]: payload.data
      };
    }
    default:
      return state;
  }
};
